<template>
  <div class="box">
    <img :src="imgUrl" />
    <div class="content">
      <el-button type="primary" @click="goHome">GO HOME</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "page404",
  data() {
    return {
      imgUrl: null,
    };
  },
  computed:{
    languages(){
      return this.$store.getters.languages || []
    }
  },
  created() {
    const index = Math.floor(Math.random() * (33 - 1 + 1)) + 1;
    this.imgUrl = `/static/404/${index}.png`;
  },
  methods: {
    goHome() {
      let languageId = this.languages[0].id || 1;
      this.$router.push("/admin/index?languageId=" + languageId);
    },
  },
};
</script>
<style scoped lang="less">
.box {
  width: 60%;
  margin: 80px auto 0 auto;
  .content {
    text-align: center;
  }
}
@media screen and(min-width:1000px) {
  .box {
    width: 40%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/error/page404.vue